import { render, staticRenderFns } from "./ServiceLimits.vue?vue&type=template&id=645a706f&"
import script from "./ServiceLimits.vue?vue&type=script&lang=js&"
export * from "./ServiceLimits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('645a706f')) {
      api.createRecord('645a706f', component.options)
    } else {
      api.reload('645a706f', component.options)
    }
    module.hot.accept("./ServiceLimits.vue?vue&type=template&id=645a706f&", function () {
      api.rerender('645a706f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/ServiceLimits.vue"
export default component.exports